import request from '@/utils/request'
import queryString from 'querystring'

export function loginIn(data) {
    return request({
        url: '/users/login',
        method: 'post',
        data: data
    })
}
// 获取用户信息（登录成功后拉取，用于写 localStorage）
export function userInfo(data) {
    return request({
        url: '/users/mine/info',
        method: 'post',
        data: data
    })
}
// 获取认证状态（登录成功后拉取，用于写 localStorage）
export function authInfo(data) {
    return request({
        url: '/users/auth/center/auth/query',
        method: 'post',
        data: data
    })
}

// 修改昵称
export function updateNickname(data) {
    return request({
        url: '/users/upd/nickname',
        method: 'post',
        data: queryString.stringify(data)
    })
}

// 获取图形验证码
export function getCaptchaImage(type) {
    return request({
        url: '/users/captchaImage',
        method: 'get',
        params: { type }
    })
}
// 发送短信验证码（先通过弹窗图形验证码）
// type: 2登录 4注册 6找回密码
export function smsCaptcha(data) {
    return request({
        url: '/users/smsCaptcha',
        method: 'post',
        data: queryString.stringify(data)
    })
}

// 用户注册
export function registerUser(data) {
    return request({
        url: '/users/register',
        method: 'post',
        data: data
    })
}

// 忘记密码 / 重置密码（字段：telephone、captchaCode、password、imgCode、imgUuid）
export function resetPassword(data) {
    return request({
        url: '/users/back',
        method: 'post',
        data: data
    })
}